import * as React from "react"

export const NotFoundPage = () => (
    <p>NotFoundPage</p>
)
